import { createContext, useContext, useEffect, type ReactNode } from "react";

type Theme = "light";
type ThemeCtx = { theme: Theme; setTheme: (t: Theme) => void; toggle: () => void };

const Ctx = createContext<ThemeCtx | undefined>(undefined);

// Dark mode has been temporarily disabled across the app.
// This provider forces light mode and clears any previously persisted preference.
const value: ThemeCtx = { theme: "light", setTheme: () => {}, toggle: () => {} };

export function ThemeProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("dark");
    root.style.colorScheme = "light";
    try {
      window.localStorage.removeItem("doctorsx-theme");
    } catch {}
  }, []);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useTheme() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useTheme must be used within ThemeProvider");
  return ctx;
}
